import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import Select from '../../../../../components/input/Select';
import CountOfTotal from '../../../../../components/CountOfTotal';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import {
  ORDER_ITEM_CANCEL_SALES_TYPE_SELECT_LIST,
  MAXIMUM_NUMBER_OF_CANCEL_SALES_REASON_TEXT,
} from '../../../../../constants/service/app/orderConstants';
import { formRequiredRules } from '../../../../../lib/formRules';
import './CancelSalesModal.scss';

const CancelSalesModal = (props) => {
  const { isOpen, form, onSubmit, setData, closeModal, reasonType, reason } = props;

  return (
    <Modal
      title="판매 취소"
      isOpen={isOpen}
      width={670}
      height={310}
      isFooter={true}
      okText="판매 취소"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="cancel-sales-modal-wrap">
        <div className="cancel-sales-info">
          <div>* 판매자 귀책사유에 의한 취소 처리시 구매자에게 추가배송비가 청구되지 않습니다.</div>
          <div>* 상품품절 취소처리시 취소 대상 상품도 품절 처리가 됩니다.</div>
          <div>단, 옵션별 재고수량 관리 상품은 취소되는 주문의 옵션만 품절 처리 됩니다.</div>
        </div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">판매 취소 사유</td>
              <td className="tl" colSpan={3}>
                <Select
                  list={ORDER_ITEM_CANCEL_SALES_TYPE_SELECT_LIST}
                  onChange={(id) =>
                    setData({
                      name: 'reasonType',
                      value: id,
                    })
                  }
                  value={reasonType}
                  size="default"
                  isTable={true}
                />
              </td>
            </tr>
            <tr>
              <td className="label tc">
                <span>구매자에게 전하실 말씀</span>
                <CountOfTotal content={reason} maxCnt={MAXIMUM_NUMBER_OF_CANCEL_SALES_REASON_TEXT} />
              </td>
              <td className="tl" colSpan={3}>
                <TextAreaForm
                  form={form}
                  name="reason"
                  rules={[formRequiredRules(true, null)]}
                  initialValue={reason}
                  onChange={(value) =>
                    setData({
                      name: 'reason',
                      value,
                    })
                  }
                  maxLength={MAXIMUM_NUMBER_OF_CANCEL_SALES_REASON_TEXT}
                />
              </td>
            </tr>
          </tbody>
        </InfoTable>

        <div className="cancel-sales-info">
          <div className="caution">
            * 입력하신 내용은 처리 후 수정이 불가합니다. 취소 사유를 정확하게 선택해 주세요.
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CancelSalesModal;
